<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        color="background: rgba(251, 109, 59, 0.15)"
        class="avatar-text"
        size="50"
        v-bind="attrs"
        v-on="on"
      >
        <span style="" class="text-white" v-if="user">
          {{ toLatin(user.name.charAt(0).toUpperCase()) }}
          {{
            user.lastname != null ? toLatin(user.lastname.charAt(0).toUpperCase()) : ""
          }}
        </span>
      </v-avatar>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in reportGuestMenuItems"
        :key="index"
        @click="$router.push(item.to)"
      >
        <v-list-item-title>
          <v-icon v-html="item.icon" small class="pr-2"></v-icon>
          {{ $t(item.title) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppReportGuestAvatarMenu",
  computed: {
    user() {
      return this.$store.state.user.user;
    },

    reportGuestMenuItems() {
      return [
        {
          title: this.$t("guest_report"),
          icon: "mdi-home",
          to: { name: "guest-report" },
        },
        {
          title: "Инфо",
          icon: "mdi-information ",
          to: { name: "info" },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.avatar-text {
  color: $primary-color;
  font-size: 13px;
}
</style>
